@if (filteredLinks().length) {
  <section
    class="p-4 bg-white mb-mobileGap tablet:mb-tabletGap desktop:mb-desktopGap tablet:p-5 desktop:p-6"
  >
    <h2
      class="text-mobileH2 tablet:text-tabletH2 font-headline mb-4 desktop:text-desktopH2 tablet:mb-5 desktop:mb-6"
    >
      {{ data().title }}
    </h2>
    <ul class="divide-y divide-[#F1EDED]" role="list">
      @for (linkItem of filteredLinks(); track $index) {
        <li role="listitem">
          <sc-link-item-widget [linkItem]="linkItem"></sc-link-item-widget>
        </li>
      }
    </ul>
  </section>
}
